import { render, staticRenderFns } from "./HeaderDashboard.vue?vue&type=template&id=7f61c066&scoped=true"
import script from "./HeaderDashboard.vue?vue&type=script&lang=ts"
export * from "./HeaderDashboard.vue?vue&type=script&lang=ts"
import style0 from "./HeaderDashboard.vue?vue&type=style&index=0&id=7f61c066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f61c066",
  null
  
)

export default component.exports